<template>
    <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Oasis Zertifikat editieren</h3>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent="editOasisCert($route.params.id)">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Angaben zum Oasis Zertifikat</h6>
                    <certform ref="LForm"/>
                    <!-- Address -->
                    <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Zertfikat ändern</span></button>
                </form>
            </template>
        </card>
</template>

<script>
    import Certform from "@/views/OasisCerts/Certform";
    export default {
        name: "edit",
        components: {Certform},
        data() {
            return {
                isLoading: false,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        created() {
            this.showOasisCert(this.$route.params.id)
        },
        computed: {

        },
        methods: {
            locationdata () {
                return this.$refs.LForm.location;
            },
            showOasisCert(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    const requestOptions = {
                        method: 'GET',
                        headers: header,
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/oasis_certs/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.$refs.LForm.cert = response;
                                //if (typeof response.state !== 'undefined') this.$refs.LForm.location.state = response.state['@id'];
                                //if (typeof response.customer !== 'undefined') this.$refs.LForm.location.customer = response.customer['@id'];
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            editOasisCert(id) {
                return new Promise(() => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/merge-patch+json';
                    let senddata = this.$refs.LForm.cert;
                    senddata.customer = senddata.customer['@id'];
                    const requestOptions = {
                        method: 'PATCH',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    this.isLoading = true;
                    fetch(process.env.VUE_APP_API_SERVER + `/api/oasis_certs/`+id, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                this.isLoading = false;
                                this.status =  {type: 'success', msg: 'Oasis Zertifikat '+response.name+' (ID: '+response.id+') wurde editiert.'};
                            },
                            error => {
                                this.isLoading = false;
                                this.status =  {type: 'danger', msg: error};
                            });
                });
            },
            isAdmin() {
                return this.$store.getters['authentication/isAdmin'];
            }
        }
    }
</script>

<style scoped>

</style>